'use strict';

/**
 * Leads: the old "Unassigned Lead" and "Assigned Lead" pages in one, with an All / Assigned / Unassigned filter.
 * Unassigned = leadStatus LEAD, Assigned = ASSIGNED or APPOINTMENT (the statuses the two old pages showed).
 * Every action of the old pages is here: add, edit, delete, assign (one or several), assign with an appointment,
 * unassign. The filter is in the URL (l.f); the old addresses open this page with their filter.
 */
angular.module('scrapQcrmApp')
    .controller('LeadsCtrl', function ($scope, tableState, $state, $rootScope, dashboard, consumer, $global, $uibModal, growl, $log, $moment) {

        var STATUSES = {
            unassigned: ['LEAD'],
            assigned: ['ASSIGNED', 'APPOINTMENT']
        };
        STATUSES.all = STATUSES.unassigned.concat(STATUSES.assigned);
        var MAX_ROWS = 5000; // newest first; the page says so when there are more

        $scope.filters = [
            { key: 'all', label: 'All' },
            { key: 'assigned', label: 'Assigned' },
            { key: 'unassigned', label: 'Unassigned' }
        ];
        $scope.leadFilter = 'all';
        $scope.counts = { all: null, assigned: null, unassigned: null };
        $scope.loading = false;
        $scope.loadError = false;
        $scope.disableAssignLeadButton = true;

        function isUnassigned(lead) {
            return STATUSES.unassigned.indexOf(lead && lead.leadStatus) >= 0;
        }

        // ---------- grid ----------

        function iconRenderer(icon, title, show) {
            function Renderer() {
            }
            Renderer.prototype.init = function (params) {
                this.eGui = document.createElement('div');
                this.eGui.style.textAlign = 'center';
                this.eGui.style.width = '100%';
                if (params.data && (!show || show(params.data))) {
                    this.eGui.innerHTML = '<i class="md ' + icon + '" style="margin: 0 auto"></i>';
                    this.eGui.setAttribute('title', title);
                }
            };
            Renderer.prototype.getGui = function () {
                return this.eGui;
            };
            return Renderer;
        }

        function dateText(value) {
            return value ? $moment(value).format('YYYY-MM-DD HH:mm:ss') : '';
        }

        var columnDefs = [
            {
                // only in the Unassigned view: several unassigned leads can be ticked and assigned at once
                headerName: "", colId: "select", hide: true, pinned: 'left',
                headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true,
                checkboxSelection: true,
                resizable: false, sortable: false, filter: false, suppressMenu: true,
                minWidth: 48, maxWidth: 48
            },
            { headerName: "Mobile", field: "mobileNo", minWidth: 130, cellStyle: { 'text-align': 'left' } },
            { headerName: "Name", field: "name", cellStyle: { 'text-align': 'left' } },
            { headerName: "User Type", field: "userType", cellStyle: { 'text-align': 'left' } },
            { headerName: "Customer Type", field: "categories.value", cellStyle: { 'text-align': 'left' } },
            { headerName: "Sales Person Name", field: "personIncharge.name", cellStyle: { 'text-align': 'left' } },
            { headerName: "Area", field: "address.address", cellStyle: { 'text-align': 'left' } },
            {
                headerName: "Inception Date", field: "createdAt", hide: true,
                valueFormatter: function (params) { return dateText(params.value); }
            },
            {
                headerName: "Status", field: "leadStatus", cellStyle: { 'text-align': 'left' },
                valueFormatter: function (params) { // Unassigned / Assigned / Appointment
                    var status = isUnassigned(params.data) ? 'unassigned' : String(params.value || '').toLowerCase();
                    return status.charAt(0).toUpperCase() + status.slice(1);
                }
            },
            {
                headerName: "Appointment Date", field: "appointmentDate",
                valueFormatter: function (params) { return dateText(params.value); }
            },
            { headerName: "Type", field: "appointmentType" },
            { headerName: "Duration", field: "appointmentDuration" },
            {
                headerName: "Edit", colId: "edit", cellRenderer: iconRenderer('md-mode-edit', 'Edit lead'),
                resizable: false, sortable: false, filter: false, maxWidth: 34, skipHeader: true, pinned: 'right',
                cellStyle: { 'height': '100%', 'display': 'flex', 'color': "#449c45" }
            },
            {
                headerName: "Delete", colId: "delete", cellRenderer: iconRenderer('md-delete', 'Delete lead'),
                resizable: false, sortable: false, filter: false, maxWidth: 34, skipHeader: true, pinned: 'right',
                cellStyle: { 'height': '100%', 'display': 'flex', 'color': "#449c45" }
            },
            {
                // only in the Assigned view, where every row has a sales person to remove
                headerName: "Unassign Lead", colId: "unassign", hide: true,
                cellRenderer: iconRenderer('md-remove-circle-outline', 'Unassign lead', function (lead) { return !isUnassigned(lead); }),
                resizable: false, sortable: false, filter: false, maxWidth: 34, skipHeader: true, pinned: 'right',
                cellStyle: { 'height': '100%', 'display': 'flex', 'color': "#449c45" }
            },
            {
                headerName: "Book Appointment", colId: "appointment",
                cellRenderer: iconRenderer('md-assignment-ind', 'Assign with an appointment'),
                resizable: false, sortable: false, filter: false, maxWidth: 50, skipHeader: true, pinned: 'right',
                cellStyle: { 'height': '100%', 'display': 'flex', 'padding': '0', 'color': "#449c45" }
            }
        ];

        $scope.gridOptions = {
            columnDefs: columnDefs,
            defaultColDef: { flex: 1, minWidth: 140, filter: true, sortable: true, resizable: true },
            rowSelection: 'multiple',
            suppressRowClickSelection: true,
            isRowSelectable: function (node) {
                return isUnassigned(node.data);
            },
            onSelectionChanged: function () {
                $scope.$applyAsync(function () {
                    $scope.disableAssignLeadButton = !selectedUnassigned().length;
                });
            },
            rowStyle: { background: '#f4f4f4' },
            getRowStyle: function (params) {
                if (params.node.rowIndex % 2 === 0) {
                    return { background: 'white' };
                }
            },
            pagination: true,
            paginationPageSize: 50,
            rowData: [],
            suppressCsvExport: true,
            suppressExcelExport: true,
            overlayNoRowsTemplate: '<span class="text-muted">No leads for this filter</span>',
            onGridReady: function (params) {
                showColumnsForFilter();
                params.api.setRowData($scope.lead_list || []);
            },
            onCellClicked: function (event) {
                if (!event || !event.data) {
                    return;
                }
                var col = event.column.getColId();
                if (col === 'edit') {
                    $scope.openModalAction('edit', event.data);
                } else if (col === 'delete') {
                    if (confirm("Do you want to Delete the Lead?")) {
                        $scope.deleteLead(event.data);
                    }
                } else if (col === 'unassign' && !isUnassigned(event.data)) {
                    if (confirm("Do you want to UnAssign the Lead?")) {
                        $scope.unAssignLead(event.data);
                    }
                } else if (col === 'appointment') {
                    $scope.openModalAction('assign', event.data, 'single');
                }
            }
        };

        // each view shows only the tools that apply to all of its rows, so no column is half empty
        function showColumnsForFilter() {
            if (!$scope.gridOptions.columnApi) {
                return;
            }
            $scope.gridOptions.columnApi.setColumnVisible('select', $scope.leadFilter === 'unassigned');
            $scope.gridOptions.columnApi.setColumnVisible('unassign', $scope.leadFilter === 'assigned');
        }

        function selectedUnassigned() {
            if (!$scope.gridOptions.api) {
                return [];
            }
            return $scope.gridOptions.api.getSelectedRows().filter(isUnassigned);
        }

        // ---------- data ----------

        var subAreas = null;
        function getSubAreas() {
            if (subAreas) {
                return Promise.resolve(subAreas);
            }
            return dashboard.getAllCity().then(function (res) {
                var list = [];
                if (res && res.status === 'SUCCESS' && res.data && res.data.cities) {
                    $rootScope.allCityData = res.data.cities;
                    res.data.cities.forEach(function (elem) {
                        if (elem.name === $rootScope.loginData.city && list.indexOf(elem.subarea) < 0) {
                            list.push(elem.subarea);
                        }
                    });
                }
                subAreas = list;
                return list;
            });
        }

        function search(statuses, limit, areas) {
            return consumer.loadLead({
                fromDate: null,
                toDate: null,
                leadStatus: statuses,
                sort: { byCreatedDate: -1 },
                skip: 0,
                limit: limit,
                subAreasOfCurrentCity: areas
            });
        }

        var requestId = 0;
        $scope.loadLeads = function () {
            var mine = ++requestId; // a slower older answer never replaces a newer one
            $scope.loading = true;
            $scope.loadError = false;
            getSubAreas().then(function (areas) {
                return Promise.all([
                    search(STATUSES[$scope.leadFilter], MAX_ROWS, areas),
                    search(STATUSES.unassigned, 1, areas), // counts only
                    search(STATUSES.assigned, 1, areas)
                ]);
            }).then(function (results) {
                if (mine !== requestId) {
                    return;
                }
                var list = results[0], un = results[1], as = results[2];
                if (!list || list.status !== 'Success') {
                    throw new Error('lead search failed');
                }
                $scope.$applyAsync(function () {
                    $scope.counts.unassigned = un && un.status === 'Success' ? un.total : null;
                    $scope.counts.assigned = as && as.status === 'Success' ? as.total : null;
                    $scope.counts.all = $scope.counts.unassigned !== null && $scope.counts.assigned !== null ?
                        $scope.counts.unassigned + $scope.counts.assigned : null;
                    $scope.lead_list = list.data || [];
                    $scope.listTotal = list.total || $scope.lead_list.length;
                    $scope.loading = false;
                    $scope.disableAssignLeadButton = true;
                    showColumnsForFilter();
                    if ($scope.gridOptions.api) {
                        $scope.gridOptions.api.setRowData($scope.lead_list);
                    }
                });
            }).catch(function (err) {
                console.error('Error loading leads', err);
                $scope.$applyAsync(function () {
                    if (mine === requestId) {
                        $scope.loading = false;
                        $scope.loadError = true;
                    }
                });
            });
        };

        // same look as the Sales Team filter: the selected one is filled with its colour
        var FILTER_COLORS = { all: '#4c5667', assigned: '#21a548', unassigned: '#f0ad4e' };
        $scope.filterButtonStyle = function (key) {
            if ($scope.leadFilter === key) {
                return { 'background-color': FILTER_COLORS[key], 'border-color': FILTER_COLORS[key], 'color': '#fff' };
            }
            return { 'background-color': '#fff', 'border-color': '#ccc', 'color': '#555' };
        };

        $scope.setFilter = function (key) {
            if (STATUSES[key] && key !== $scope.leadFilter) {
                $scope.leadFilter = key;
                $scope.loadLeads();
            }
        };

        // ---------- actions (as on the old pages) ----------

        $scope.openModalAction = function (action, userData, mode) {
            var modalInstance = $uibModal.open({
                templateUrl: 'views/add-lead.html',
                controller: 'AddLeadCtrl',
                size: "lg",
                backdrop: 'static',
                resolve: {
                    items: function () { return 'CONSUMER'; },
                    action: function () { return action; },
                    userData: function () { return userData; },
                    mode: function () { return mode; }
                }
            });
            modalInstance.result.then(function () {
                $scope.loadLeads();
            }, function () {
                $log.info('Modal dismissed at: ' + new Date());
                $scope.loadLeads();
            });
        };

        $scope.assignLead = function () {
            var ids = selectedUnassigned().map(function (lead) {
                return lead._id;
            });
            if (ids.length) {
                $scope.openModalAction('assign', ids, 'multiple');
            }
        };

        $scope.deleteLead = function (leadData) {
            consumer.deleteLead({ id: leadData._id, mobileNo: leadData.mobileNo }).then(function (res) {
                if (res && res.status === 'Success') {
                    growl.success('Lead deleted');
                } else {
                    growl.error((res && res.message) || 'Could not delete the lead');
                }
                $scope.loadLeads();
            });
        };

        $scope.unAssignLead = function (leadData) {
            consumer.unAssignLead({ id: leadData._id }).then(function (res) {
                if (res && res.status === 'Success') {
                    growl.success('Lead unassigned');
                } else {
                    growl.error((res && res.message) || 'Could not unassign the lead');
                }
                $scope.loadLeads();
            });
        };

        // the filter is kept in the URL: Back / refresh / the old addresses open the same view
        tableState.page($scope, 'l', {
            controls: {
                f: {
                    model: 'leadFilter', type: 'string',
                    validate: function (v) { return !!STATUSES[v]; },
                    onRestore: function () { $scope.loadLeads(); }
                }
            },
            grids: { g: 'gridOptions' }
        });

        $scope.loadLeads();
    });
